
// Tier 1 Activity Event Types for Core Value Features
export interface AnalyticsEventData {
  // Content Saving Events
  content_saved?: {
    content_id: string;
    source_method: 'manual' | 'extension' | 'bookmark_import';
    content_type: string;
    url_domain?: string;
    has_title: boolean;
    has_description: boolean;
  };
  
  // Organization & Curation Events
  collection_created?: {
    collection_id: string;
    name: string;
    color: string;
  };
  
  tag_created?: {
    tag_id: string;
    name: string;
    color: string;
  };
  
  board_created?: {
    board_id: string;
    name: string;
    color: string;
  };
  
  content_organized?: {
    content_id: string;
    action: 'added_to_collection' | 'tagged' | 'added_to_board' | 'removed_from_collection' | 'untagged' | 'removed_from_board';
    target_id: string;
    target_type: 'collection' | 'tag' | 'board';
  };
  
  content_edited?: {
    content_id: string;
    fields_changed: string[];
    edit_frequency_score?: number;
  };
  
  // Content Discovery Events
  navigation_used?: {
    navigation_type: 'collection' | 'tag' | 'board' | 'inbox' | 'archive';
    target_id?: string;
    target_name?: string;
    content_count?: number;
  };
  
  search_used?: {
    search_term: string;
    results_count: number;
    result_clicked?: boolean;
    search_duration_ms?: number;
  };
  
  // Browser Extension Detection
  extension_detected?: {
    extension_version?: string;
    browser_type?: string;
  };
}

// Core Tier 1 Event Types
export const TIER_1_EVENTS = {
  // Content Saving
  CONTENT_SAVED_MANUAL: 'content_saved_manual',
  CONTENT_SAVED_EXTENSION: 'content_saved_extension', 
  CONTENT_SAVED_IMPORT: 'content_saved_import',
  EXTENSION_INSTALLED: 'extension_installed',
  BOOKMARK_IMPORT_STARTED: 'bookmark_import_started',
  BOOKMARK_IMPORT_COMPLETED: 'bookmark_import_completed',
  
  // Organization & Curation
  COLLECTION_CREATED: 'collection_created',
  TAG_CREATED: 'tag_created',
  BOARD_CREATED: 'board_created',
  CONTENT_ADDED_TO_COLLECTION: 'content_added_to_collection',
  CONTENT_TAGGED: 'content_tagged',
  CONTENT_ADDED_TO_BOARD: 'content_added_to_board',
  CONTENT_EDITED: 'content_edited',
  
  // Content Discovery  
  NAVIGATION_COLLECTION: 'navigation_collection',
  NAVIGATION_TAG: 'navigation_tag',
  NAVIGATION_BOARD: 'navigation_board',
  SEARCH_PERFORMED: 'search_performed',
  SEARCH_RESULT_CLICKED: 'search_result_clicked',
} as const;

export type Tier1EventType = typeof TIER_1_EVENTS[keyof typeof TIER_1_EVENTS];
